import { render, staticRenderFns } from "./applicantTabs.vue?vue&type=template&id=2650c34d&"
import script from "./applicantTabs.vue?vue&type=script&lang=js&"
export * from "./applicantTabs.vue?vue&type=script&lang=js&"
import style0 from "./applicantTabs.vue?vue&type=style&index=0&id=2650c34d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports